import { useQuery } from "@tanstack/react-query";
import { fetchOrganizationAreaIndicatorsData } from "../../../services/b2b-plans-apiService";
import { showNotification } from "../../b2b-common/Notification";
import { useLoginContext } from "../../../App";
import { useContentContext } from "../../layout/Layout";
import useB2BTranslation from "../../b2b-common/hooks/useB2BTranslation";
import { useState } from "react";

const useOrgAreaIndicators = (loadFactor) => { 
    const { loginData } = useLoginContext();
    const { setNotification } = useContentContext();
    const { t } = useB2BTranslation('b2b-plans');

    const [isSearching, setIsSearching] = useState(false);

    const gettingOrgAreaIndicators = async (loadFactor) => {
        try {
            setIsSearching(true);
            const data = await fetchOrganizationAreaIndicatorsData(loginData.accessToken, loadFactor);
            return data;
        } catch (error) {
            showNotification(setNotification, t('Error fetching organization area indicators'), 'error', 5000);
        } finally {
            setIsSearching(false);
        }
    }

    const { data: organizationAreaIndicatorsData } = useQuery({
        queryKey: ['orgAreaIndicatorsData', loadFactor, loginData.loggedOrganizationUuid],
        queryFn: () => gettingOrgAreaIndicators(loadFactor),
        enabled: !!loadFactor,
    });

    // console.log(loadFactor);

    return { organizationAreaIndicatorsData, isSearching };
};

export default useOrgAreaIndicators;